module.exports = __webpack_public_path__ + "static/media/loading.e362f693.gif";